var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYotiIconEyewear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "65px",
    height: "37px",
    viewBox: "0 0 65 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_eyewear") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "age-scan->-user-experience",
    transform: "translate(-818.000000, -2729.000000)",
    stroke: "#000000",
    strokeWidth: 2.86046512
  }, /*#__PURE__*/React.createElement("g", {
    id: "page-content",
    transform: "translate(352.000000, 537.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "guidance",
    transform: "translate(9.000000, 2016.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "guidance-example",
    transform: "translate(159.000000, 172.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(270.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_eyewear",
    transform: "translate(30.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7868227,15.2101657 L16.8488547,13.4559855 M4.36685756,5.81389535 L20.5435029,0.428354651 C24.1616337,-0.837758721 28.1180145,1.07768023 29.3805523,4.70653779 M38.0073576,16.8824651 L51.8294826,12.2806919 C55.672875,10.9359157 59.8748983,12.970064 61.2157413,16.8252558 M8.22598256,26.1993576 C3.6832064,24.9782965 0,19.4636773 0,13.8811221 L0,10.7989709 C0,7.65031395 2.07669767,5.65692733 4.6389593,6.34522674 L11.8133634,8.27282267 C14.375625,8.96112209 16.4523227,12.0715203 16.4523227,15.2201773 L16.4523227,18.3019709 C16.4523227,23.8848837 12.7694738,27.420061 8.22598256,26.1993576 Z M31.204814,32.9554186 C26.6620378,31.7343576 22.9788314,26.2197384 22.9788314,20.6371831 L22.9788314,17.555032 C22.9788314,14.4070901 25.0558866,12.4129884 27.6174331,13.1012878 L34.7921948,15.0292413 C37.3540988,15.7178983 39.4311541,18.8275814 39.4311541,21.9758808 L39.4311541,25.058032 C39.4311541,30.6409448 35.7483052,34.1764797 31.204814,32.9554186 L31.204814,32.9554186 Z",
    id: "Shape"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYotiIconEyewear);
export default __webpack_public_path__ + "static/media/Yoti_icon_eyewear.c550bfdbff4509364e7a6b2478ff7587.svg";
export { ForwardRef as ReactComponent };